import styled from 'styled-components';

export default styled.div`
  color: #721c24;
`;
